/* eslint-disable no-param-reassign */

const config = {
    resizeTimeout: 250,
};

const states = {
    mobile: 1,
    desktop: 2,
};

export default class AdaptiveTrait {

    static resizedEventCreated = false;

    constructor(target, maxWidth = '768px') {

        AdaptiveTrait.initResizedEvent();

        if (typeof (target) != 'object')
            throw new Error('Target param must be object');

        if (target.renderMobile == undefined || target.renderDesktop == undefined)
            throw new Error(`${target.constructor.name} required renderMobile and renderDesktop methods`);

        this.target = target;
        this.targetComponentDidMount = target.componentDidMount
            ? target.componentDidMount.bind(target)
            : null;

        this.targetComponentWillUnmount = target.componentWillUnmount
            ? target.componentWillUnmount.bind(target)
            : null;

        target.render = this.render.bind(this);
        target.componentDidMount = this.componentDidMount.bind(this);
        target.componentWillUnmount = this.componentWillUnmount.bind(this);

        this.maxWidth = maxWidth;
        
        this.lastState = this.getCurrentState();
    }

    getCurrentState() {

        return AdaptiveTrait.isMobile(this.maxWidth)
            ? states.mobile
            : states.desktop;
    }

    componentDidMount() {

        if (this.targetComponentDidMount != undefined)
            this.targetComponentDidMount();

        if (!this.event) {

            this.event = () => {
                
                const newState = this.getCurrentState();
                if (this.lastState != newState) {

                    this.lastState = newState;
                    this.target.setState({ adaptive: 'changed' });
                }
            };

            window.addEventListener('resized', this.event);
        }
    }

    componentWillUnmount() {

        if (this.targetComponentWillUnmount != undefined)
            this.targetComponentWillUnmount();

        if (this.event) {

            window.removeEventListener('resize', this.event);
            this.event = null;
        }
    }

    render() {

        return AdaptiveTrait.isMobile(this.maxWidth)
            ? this.target.renderMobile()
            : this.target.renderDesktop();
    }

    static initResizedEvent() {

        if (!AdaptiveTrait.resizedEventCreated) {

            AdaptiveTrait.resizedEventCreated = true;

            let timeoutId = null;
            window.addEventListener('resize', () => {

                if (timeoutId)
                    clearTimeout(timeoutId);

                timeoutId = setTimeout(() => {

                    timeoutId = null;
                    window.dispatchEvent(new CustomEvent('resized'));
                }, config.resizeTimeout);
            });
        };
    }

    static addResizeEvent(callback) {

        AdaptiveTrait.initResizedEvent();
        window.addEventListener('resized', callback);
    }

    static removeResizeEvent(callback) {

        window.removeEventListener('resized', callback);
    }

    static isMobile(maxWidth = '768px') {

        return window.matchMedia(`all and (max-width: ${maxWidth})`).matches;
    }

}